import script from "./WishLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./WishLogin.vue?vue&type=script&setup=true&lang=js"

import "./WishLogin.vue?vue&type=style&index=0&id=6af836d4&scope=true&lang=css"

const __exports__ = script;

export default __exports__